import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpNewBlackjackMakeDecision implements ICommand
{

	public GameID : number = 0;
	public Decision : number = 0;
	public Reason : number = 0;
	public Type : number = 0;
	public Seat : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readUint53();
		this.Decision = ba.readUint32();
		this.Reason = ba.readUint32();
		this.Type = ba.readUint32();
		this.Seat = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);
		ba.writeUint32(this.Decision);
		ba.writeUint32(this.Reason);
		ba.writeUint32(this.Type);
		ba.writeUint32(this.Seat);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpNewBlackjackMakeDecision();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'Decision(D)='+this.Decision+' ';
		str += 'Reason(D)='+this.Reason+' ';
		str += 'Type(D)='+this.Type+' ';
		str += 'Seat(D)='+this.Seat+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50143;
	}

	public getCmdName() : string
	{
		return 'SpNewBlackjackMakeDecision';
	}

}
